import { useEffect } from 'react';
import { useServices } from '@/model';
import { agentRuntime } from './data';

/** The App forgets the intro preference on account removal independently of the visited screen. */
export function AssistantIntroRuntime() {
    const services = useServices();
    useEffect(() => agentRuntime(services).observeIntroRemoval(), [services]);
    return null;
}
